import axios from 'axios'

export class KassenprojektArtikel{
    static async get(kassenProjektID, feuerwehrID, timeout = 1500){
        try {
            const response = await axios.get(
              'https://feuerwehr-server.org:5000/kassenprojektArtikel', { params: { kassenProjektID: kassenProjektID, feuerwehrID: feuerwehrID  }, timeout }
            );
              console.log(response.data);
              return response.data;
          } catch (err) {
            console.error(err);
            throw err;
          }
    }
    static async add(artikel){
        try {
            const response = await axios.post('https://feuerwehr-server.org:5000/addKassenprojektArtikel', artikel);
            console.log(response.data);
        } catch (err) {
            console.error(err);
        }
    }
    static async update(artikel, timeout = 1500){
        try {
            const response = await axios.put('https://feuerwehr-server.org:5000/updateKassenprojektArtikel', artikel,{timeout});
            console.log(response.data);
            return true;
         } catch (err) {
            console.error(err);
            throw err;
        }
    }
    static async delete(a){
        try{
            const response = await axios.delete(
                'https://feuerwehr-server.org:5000/deleteKassenprojektArtikel',
                { params: { kassenProjektID: a.kassenProjektID, feuerwehrID: a.feuerwehrID, kassenProjektArtikelID: a.kassenProjektArtikelID } }
            );
            console.log(response.data);
            return true;
        } catch (err){
            console.log(err);
            return false;
        }
    }
}